module.exports = __webpack_public_path__ + "img/ma.44e8cfc.svg";